import {
  APIProvider,
  Map,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { useContext } from "react";

type GoogleMapsContextProps = {
  map: google.maps.Map | null;
  placesLib: google.maps.PlacesLibrary | null;
};

const GoogleMapsContext = React.createContext<GoogleMapsContextProps>({
  placesLib: null,
  map: null,
});

function _GoogleMapsProvider({ children }: React.PropsWithChildren) {
  const map = useMap("hidden-map");
  const placesLibrary = useMapsLibrary("places");

  return (
    <GoogleMapsContext.Provider value={{ placesLib: placesLibrary, map }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

export function GoogleMapsProvider({ children }: React.PropsWithChildren) {
  return (
    <APIProvider
      apiKey="AIzaSyCMqgARtpOt0ADXjvJTEWwdpbyvEsPkabo"
      libraries={["places"]}
    >
      <Map id="hidden-map" style={{ display: "none" }} />
      <_GoogleMapsProvider children={children} />
    </APIProvider>
  );
}

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}
